import { render } from "./mpesaPayments.vue?vue&type=template&id=b4bb270a&scoped=true"
import script from "./mpesaPayments.vue?vue&type=script&lang=js"
export * from "./mpesaPayments.vue?vue&type=script&lang=js"

import "./mpesaPayments.vue?vue&type=style&index=0&id=b4bb270a&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/cleanshift_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4bb270a"]])

export default __exports__